export default __webpack_public_path__ + "static/media/sticker-ve.6484e618.png";